module.exports = __webpack_public_path__ + "img/dodSearchIcon.b5f0987a.svg";